import { ArrayUtils, Encoder, Utils } from '@everyboard/lib';
import { Player } from '../../jscaip/Player';
const HivePieceKindEncoder = Encoder.fromFunctions((value) => value, (json) => json);
export class HivePiece {
    owner;
    kind;
    static encoder = Encoder.tuple([Player.encoder, HivePieceKindEncoder], (piece) => [piece.owner, piece.kind], (fields) => new HivePiece(fields[0], fields[1]));
    constructor(owner, kind) {
        this.owner = owner;
        this.kind = kind;
    }
    toString() {
        return `${this.kind}_${this.owner.toString()}`;
    }
    equals(other) {
        return this.owner === other.owner && this.kind === other.kind;
    }
}
export class HivePieceStack {
    pieces;
    static EMPTY = new HivePieceStack([]);
    constructor(pieces) {
        this.pieces = pieces;
    }
    equals(other) {
        if (this.size() !== other.size())
            return false;
        return ArrayUtils.equals(this.pieces, other.pieces);
    }
    isEmpty() {
        return this.pieces.length === 0;
    }
    hasPieces() {
        return this.isEmpty() === false;
    }
    add(piece) {
        return new HivePieceStack([piece, ...this.pieces]);
    }
    topPiece() {
        Utils.assert(this.hasPieces(), 'HivePieceStack: cannot get top piece of an empty stack');
        return this.pieces[0];
    }
    removeTopPiece() {
        const pieces = [...this.pieces];
        pieces.shift();
        return new HivePieceStack(pieces);
    }
    size() {
        return this.pieces.length;
    }
}
